import type { Action } from 'svelte/action';

/**
 * Button follows cursor slightly. Usage: <button use:magnetic>
 */
export const magnetic: Action<HTMLElement, { strength?: number } | undefined> = (node, params) => {
    const strength = params?.strength ?? 0.15;

    function onMove(e: MouseEvent) {
        const rect = node.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        node.style.transform = `translate(${x * strength}px, ${y * strength * 1.3}px)`;
    }
    function onLeave() {
        node.style.transform = '';
    }

    node.addEventListener('mousemove', onMove);
    node.addEventListener('mouseleave', onLeave);

    return {
        destroy() {
            node.removeEventListener('mousemove', onMove);
            node.removeEventListener('mouseleave', onLeave);
        }
    };
};
